/** @jsx h */
import './bargraph.css'
import { h } from 'preact'
import formatMoney from '../../../helpers/format-money'
import transitionIn from '../transition-in'

// const data = [
//   ['jan', 230000],
//   ['feb', 5300],
//   ['mar', 23409],
//   ['apr', 232344],
//   ['may', 452344],
//   ['jun', 430023],
//   ['jul', 5304023],
//   ['aug', 330023],
//   ['sep', 630023],
//   ['oct', 21288023],
//   ['nov', 340023],
//   ['dec', 3180023]
// ]

const BarGraph = ({ data, firstRender }) => {
  let max = 0

  const dataSet = data || []
  const length = (data && data.length) || 12

  dataSet.forEach(([month, amount]) => {
    if (amount > max) {
      max = amount
    }
  })

  if (max === 0) {
    max = 1000000
  }

  const scale =
    (() => {
      let top = max / 100
      if (top > 100000000) {
        return 50000000
      }
      if (top > 10000000) {
        return 5000000
      }
      if (top > 1000000) {
        return 500000
      }
      if (top > 100000) {
        return 50000
      }
      if (top > 100000) {
        return 50000
      }
      if (top > 10000) {
        return 5000
      }
      if (top > 1000) {
        return 500
      }
      if (top > 500) {
        return 200
      }
      if (top > 200) {
        return 100
      }
      if (top > 100) {
        return 50
      }
      return 20
    })() * 100

  const lines = Math.floor(max / scale) + 1
  let lineCounter = lines

  const lineEls = []
  const perLine = scale / max * 8

  // figure out line width
  let lineWidth = length * (0.8 + 0.25) + 3

  while (lineCounter--) {
    if (
      lines < 5 ||
      (lines >= 5 && lines < 10 && lineCounter % 2 === 0) ||
      (lines >= 10 && lineCounter % 4 === 0)
    ) {
      const amount = formatMoney(lineCounter * scale, false)
        .replace(',000,000', 'MM')
        .replace(',000', 'K')
        .replace(',500', '.5K')
      lineEls.push(
        <div
          className='absolute bb b--black-10 mr2 tr f6 black-30 pt2'
          style={{
            bottom: `${lineCounter * perLine}rem`,
            width: `${lineWidth}rem`
          }}
        >
          {amount}
        </div>
      )
    }
  }

  return (
    <div className='pb4 pt3'>
      <div className='barContainer relative nowrap'>
        {lineEls}
        {dataSet.map(([month, amount]) => {
          const formatted = formatMoney(amount)
          const scaleY = firstRender ? 0 : amount / max
          return (
            <div key={month} className='dib mr1 barWidth'>
              <div
                title={formatted}
                className='absolute dib black-50 verticalMonth tr ml3 mt6 pt3'
              >
                {month}
              </div>
              <div
                className='barGraphBar bg-green dib h4 mr1 barWidth'
                style={{
                  transform: `scaleY(${scaleY})`
                }}
                title={formatted}
              />
            </div>
          )
        })}
      </div>
    </div>
  )
}

export default transitionIn(BarGraph)
